import React, { useState, useEffect } from 'react';
import { X, Check, Settings } from 'lucide-react';
import { Button } from './ui/button';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Prüfen ob bereits zugestimmt wurde
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    setIsVisible(false);
  };

  const handleAcceptEssential = () => {
    localStorage.setItem('cookieConsent', 'essential');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="w-full max-w-2xl bg-zinc-900 border border-zinc-800 rounded-sm shadow-2xl max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-start justify-between mb-4">
            <h2 className="font-heading text-xl font-bold uppercase tracking-tight text-white">
              Datenschutz-Einstellungen
            </h2>
          </div>

          {/* Content */}
          <div className="space-y-4 text-sm text-zinc-400 leading-relaxed">
            <p>
              Wir benötigen Ihre Einwilligung, bevor Sie unsere Website weiter besuchen können.
            </p>
            
            <p>
              Wenn Sie unter 16 Jahre alt sind und Ihre Einwilligung zu optionalen Services geben möchten, 
              müssen Sie Ihre Erziehungsberechtigten um Erlaubnis bitten.
            </p>
            
            <p>
              Wir verwenden Cookies und andere Technologien auf unserer Website. Einige von ihnen sind essenziell, 
              während andere uns helfen, diese Website und Ihre Erfahrung zu verbessern. Personenbezogene Daten 
              können verarbeitet werden (z. B. IP-Adressen), z. B. für personalisierte Anzeigen und Inhalte oder 
              die Messung von Anzeigen und Inhalten. Weitere Informationen über die Verwendung Ihrer Daten finden 
              Sie in unserer Datenschutzerklärung.
            </p>
            
            <p>
              Es besteht keine Verpflichtung, in die Verarbeitung Ihrer Daten einzuwilligen, um dieses Angebot zu nutzen. 
              Sie können Ihre Auswahl jederzeit unter Einstellungen widerrufen oder anpassen. Bitte beachten Sie, dass 
              aufgrund individueller Einstellungen möglicherweise nicht alle Funktionen der Website verfügbar sind.
            </p>

            {showDetails && (
              <div className="bg-zinc-800/50 border border-zinc-700 p-4 rounded-sm mt-4">
                <p className="text-zinc-300 font-medium mb-2">Hinweis zur Datenverarbeitung in den USA:</p>
                <p>
                  Einige Services verarbeiten personenbezogene Daten in den USA. Mit Ihrer Einwilligung zur Nutzung 
                  dieser Services willigen Sie auch in die Verarbeitung Ihrer Daten in den USA gemäß Art. 49 (1) lit. a 
                  GDPR ein. Der EuGH stuft die USA als ein Land mit unzureichendem Datenschutz nach EU-Standards ein. 
                  Es besteht beispielsweise die Gefahr, dass US-Behörden personenbezogene Daten in Überwachungsprogrammen 
                  verarbeiten, ohne dass für Europäerinnen und Europäer eine Klagemöglichkeit besteht.
                </p>
              </div>
            )}
          </div>

          {/* Toggle Details */}
          <button
            onClick={() => setShowDetails(!showDetails)}
            className="flex items-center gap-2 text-sm text-primary hover:underline mt-4"
          >
            <Settings className="w-4 h-4" />
            {showDetails ? 'Weniger anzeigen' : 'Mehr erfahren'}
          </button>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 mt-6">
            <Button
              onClick={handleAcceptEssential}
              variant="outline"
              className="flex-1 h-12 border border-zinc-700 hover:border-zinc-600 bg-transparent text-white uppercase tracking-wider rounded-sm"
              data-testid="cookie-essential-btn"
            >
              Nur Essenzielle
            </Button>
            <Button
              onClick={handleAcceptAll}
              className="flex-1 h-12 bg-primary text-black font-bold uppercase tracking-wider rounded-sm hover:bg-primary/90"
              data-testid="cookie-accept-all-btn"
            >
              <Check className="w-4 h-4 mr-2" />
              Alle akzeptieren
            </Button>
          </div>

          {/* Links */}
          <div className="flex gap-4 mt-4 text-xs text-zinc-500">
            <a href="/legal" className="hover:text-zinc-300">Impressum</a>
            <a href="/legal" className="hover:text-zinc-300">Datenschutz</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
